import useStore from '../store/useStore'

export const useUnarchivedDoctors = () => {
  return useDoctors()?.docs.filter(d => !d.data().archived) || []
}

export const useDoctors = () => useStore(state => state.doctors)

export default useDoctors
